// Fire-and-forget tap tracking. Never blocks the user's navigation.
// Usage: track("call_tap", { target: "+91..." })

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

const ALLOWED = new Set(["call_tap", "whatsapp_tap", "directions_tap", "book_tap", "install_pwa"]);

export const track = (event, extra = {}) => {
  try {
    if (!ALLOWED.has(event)) return;
    const payload = JSON.stringify({
      event,
      page: typeof window !== "undefined" ? window.location.pathname + window.location.search : "",
      target: extra.target || "",
      referrer: (typeof document !== "undefined" && document.referrer) || "",
    });
    const url = `${BACKEND_URL}/api/track`;
    // sendBeacon survives page navigation (perfect for tel: / wa.me / directions clicks)
    if (typeof navigator !== "undefined" && navigator.sendBeacon) {
      const blob = new Blob([payload], { type: "application/json" });
      navigator.sendBeacon(url, blob);
      return;
    }
    // Fallback – keepalive fetch so the browser doesn't cancel it during navigation
    fetch(url, {
      method: "POST",
      body: payload,
      headers: { "Content-Type": "application/json" },
      keepalive: true,
      credentials: "include",
    }).catch(() => {});
  } catch (_e) {
    /* tracking must never break UX */
  }
};

export default track;
